export default "__VITE_ASSET__DVLDfTN8__"